import React, { forwardRef } from 'react';
import { DateTimePicker } from '../UI/DateTimePicker';

export interface PublicationExpiresAtFieldProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const PublicationExpiresAtField = forwardRef<HTMLInputElement, PublicationExpiresAtFieldProps>(({
  id = 'publicationExpiresAt',
  value,
  onChange,
  disabled = false,
}, ref) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700">
        Validade da publicação (opcional)
      </label>
      <p className="mt-0.5 text-xs text-gray-500">
        Escolha primeiro a data e depois o horário de validade. Deixe em branco para publicação sem validade.
      </p>
      <div className="mt-1.5">
        <DateTimePicker
          ref={ref}
          id={id}
          value={value}
          onChange={onChange}
          disabled={disabled}
          dateLabel="Data de validade"
          timeLabel="Horário"
          clearLabel="Limpar validade"
          selectedPrefix="Validade selecionada"
          pastMessage="A validade precisa ser uma data e hora futuras."
        />
      </div>
    </div>
  );
});

PublicationExpiresAtField.displayName = 'PublicationExpiresAtField';
